import React from 'react';
import { useClinic } from '@/contexts/ClinicContext';
import MyDayDashboard from '@/components/clinic/MyDayDashboard';
import ClinicDashboard from '@/components/clinic/ClinicDashboard';

/**
 * Role-aware index route — renders MyDayDashboard for practitioners
 * (including dual-role clinic admin + provider users in clinical mode),
 * falls back to ClinicDashboard for admin-only users.
 */
const RoleAwareIndex: React.FC = () => {
  const { isPractitioner } = useClinic();
  return isPractitioner ? <MyDayDashboard /> : <ClinicDashboard />;
};

export default RoleAwareIndex;
